import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Link } from 'react-router';
import { FORM_ERROR } from 'final-form';

import { changePassword2 } from '../../actions/auth';
import NavBarConfig from '../../components/NavBarConfig';
import ResetPasswordSettingsForm from '../../components/forms/ResetPasswordSettingsForm';


const messages = defineMessages({
  CHANGE_PASSWORD: {
    id: 'SettingsPasswordPage.CHANGE_PASSWORD',
    defaultMessage: 'Passwort ändern',
  },
  BACK: {
    id: 'SettingsPasswordPage.BACK',
    defaultMessage: 'Zurück',
  },
  CHOOSE_STRONG_PASSWORD: {
    id: 'SettingsPasswordPage.CHOOSE_STRONG_PASSWORD',
    defaultMessage: 'Bitte wähle ein starkes Passwort.',
  },
});

function SettingsPasswordPage({ onSubmit, routes, intl: { formatMessage } }) {
  return (
      <div style={{ backgroundColor: 'transparent', minHeight: '100vh', width: '100%', padding: '16px' }}>
      <NavBarConfig currentRouteName={routes[routes.length - 1].name} />
      
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        <div style={{ maxWidth: '600px' }}>
          {/* Header */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '24px' }}>
            <Link to="/settings/" onMouseDown={e => e.preventDefault()} style={{ width: '40px', height: '40px', borderRadius: '50%', backgroundColor: 'var(--btn-default-bg)', border: '1px solid var(--btn-default-border)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text-color)', textDecoration: 'none' }}>
              <i className="fa fa-arrow-left" />
            </Link>
            <div>
              <h2 style={{ margin: 0, fontSize: '28px', fontWeight: 'bold', color: 'var(--text-color)' }}>
                {formatMessage(messages.CHANGE_PASSWORD)}
              </h2>
              <div style={{ color: 'var(--text-muted)', fontSize: '14px', marginTop: '4px' }}>{formatMessage(messages.CHOOSE_STRONG_PASSWORD)}</div>
            </div>
          </div>

          {/* Main Card */}
          <div style={{ backgroundColor: 'var(--panel-bg)', borderRadius: '16px', border: '1px solid var(--panel-border)', boxShadow: '0 4px 6px -1px var(--panel-shadow)', padding: '32px' }}>
            <ResetPasswordSettingsForm onSubmit={onSubmit} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default connect(null,
  dispatch => ({
    onSubmit: async formData => {
      const data = await changePassword2(formData);
      if (data.response) {
        dispatch(push('/settings/password/success/'));
      } else {
        return { [FORM_ERROR]: data.error[Object.keys(data.error)[0]] };
      }
    },
  })
)(injectIntl(SettingsPasswordPage));
